
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/conversation",
      function () {
        return require("private-next-pages/mendable-api/conversation.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mendable-api/conversation"])
      });
    }
  